export default {
	tabs: {
		work: 'الدوام',
		vacation: 'الإجازات',
		permissions: 'الأذونات',
		mission: 'المهام',
		'fingerprints-devices': 'أجهزة البصمات',
	},
	'delete-message-attendance': 'هل انت متأكد أنك تريد حذف سجل الدوام هذا ؟'
};
